export default __webpack_public_path__ + "static/media/think-MO-line-xs.ee88aa8e.gif";